import { Language } from '@core/enums/language';

export const LANGUAGE_VARIANTS: Record<Language, string[]> = {
  'nb-NO': ['nb', 'nb-no', 'no'],
  'nn-NO': ['nn', 'nn-no'],
  'en': ['en', 'en-us', 'en-gb']
};

export const LANGUAGE_NAMES: Record<Language, string> = {
  'nb-NO': 'Bokmål',
  'nn-NO': 'Nynorsk',
  'en': 'English'
};

export const DEFAULT_LANGUAGE: Language = Language.Bokmal;
